export interface InfoCardProps {
  label: string;
  value: string;
}

/**
 * A single label/value pair on the Overview tab's "Basic Information" card (taxId, email, phone,
 * annualRevenue). Split out of the pre-Carbon `CompanyProfile.tsx` (Task 6) — the Heroicons prop
 * it used to take is dropped: those icons were purely decorative, not data, and the Carbon-style
 * tab this feeds doesn't otherwise use per-field icons (see `OverviewTab.tsx`'s own docstring).
 */
const InfoCard = ({ label, value }: InfoCardProps) => (
  <div className="company-profile__info-card">
    <p className="company-profile__info-label">{label}</p>
    <p className="company-profile__info-value">{value}</p>
  </div>
);

export default InfoCard;
